import { memo, isValidElement, ReactElement } from 'react';
import { IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  useGridApiContext,
  useGridSelector,
  gridDetailPanelExpandedRowsContentCacheSelector,
} from '@mui/x-data-grid-pro';
import { DetailPanelToggleProps } from './types';
import useAlias from '@alias';

const CustomDetailPanelToggle: React.FC<DetailPanelToggleProps> = ({
  id,
  value: isExpanded,
}): ReactElement => {
  const alias = useAlias();
  const apiRef = useGridApiContext();
  const contentCache = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowsContentCacheSelector,
  );

  const hasDetail = isValidElement(contentCache[id]);

  return (
    <IconButton
      size='small'
      tabIndex={-1}
      disabled={!hasDetail}
      aria-label={alias(isExpanded ? 'Close' : 'Open')}
    >
      <ExpandMoreIcon
        sx={(theme) => ({
          transform: `rotateZ(${isExpanded ? 180 : 0}deg)`,
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
          }),
        })}
        fontSize='inherit'
      />
    </IconButton>
  );
};

CustomDetailPanelToggle.displayName = 'CustomDetailPanelToggle';

export default memo(CustomDetailPanelToggle);
